import { render, staticRenderFns } from "./OrganisationScorecard.vue?vue&type=template&id=44663a1c"
import script from "./OrganisationScorecard.vue?vue&type=script&lang=js"
export * from "./OrganisationScorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports